import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { resizeParent } from '../../services/Utils'

// Actions
import { configure, getConfiguration } from '../../actions/Settings'
import { getGroups, getFilters } from '../../actions/Groups'


// Components
import Spinner from '../Spinner';
import SelectMenu from '../SelectMenu';
import SearchInput from '../SearchInput';
import TwentySeventeenGroupCard from './Cards/TwentySeventeenGroupCard';
import EmphasisGroupCard from './Cards/EmphasisGroupCard';
import DefaultCard from './Cards/DefaultCard';
import TCCGroupsMap from './TCCGroupsMap';
import TCCGroupsOpenMap from './TCCGroupsOpenMap';

// Styles
import styles from './Groups.css';

// Class
class TCCGroups extends Component {

    static getDerivedStateFromProps(props, state) {

        // Return null if the state hasn't changed
        return {
            groups: props.groups.groups,
            whenLabel: (!props.whenlabel) ? "When" : props.whenlabel,
            typeLabel: (!props.typelabel) ? "Type" : props.typelabel,
            regionLabel: (!props.regionlabel) ? "Region" : props.regionlabel,
            showfilters: (props.showfilters != "false") ? true : false,
            order: (!props.order) ? 'alphabetical' : props.order,
        };
        return null;
    }


    constructor(props) {

        super(props);

        this.state = {
            page: 1,
            loaded: false,
            className: styles.loading,
            category: (this.props.category && this.props.source === 'category') ? this.props.category : null,
            when: null,
            area: null,
            search: null,
            searchInterval: 0,
            groups: {},
            showMap: false,
            filteredGroups: null,
            zoom: (this.props.zoom) ? this.props.zoom : 11,
        }
    }

    getGroups() {

        let args = {
            page: this.state.page,
            category: this.state.category,
            area: this.state.area,
            when: this.state.when,
            search: this.state.search,
            source: this.props.source,
            pcoslug: this.props.pcoslug,
            ccbcategory: this.props.ccbcategory,
            order: this.props.order
        }

        this.props.getGroups(args)

    }

    componentDidMount() {

        this.props.configure(this.props.site);
        this.props.getConfiguration();

        this.getGroups();
        if (this.props.source != 'pco' && this.props.source != 'ccb') {
            this.props.getFilters({ category: this.props.category });
        }

        if (this.props.map === 'open_map') this.setState({ showMap: true })

        setTimeout(() => {

            this.setState({
                loaded: true,
                className: styles.Groups
            })

        }, 1000);
    }

    componentDidUpdate() {
        resizeParent();
    }

    applyFilter(e) {

        this.filter(e.target.name, e.target.value);

    }

    filter(name, value) {

        // this.setState({[name]:value,page:1},this.getGroups); // Sends to Server

        // Filter list locally
        // let results = this.props.groups.groups.filter


        // Original Set Filter and render.
        this.setState({ [name]: value, page: 1 }, this.filterGroups);

        // New: Set Filter before render.


    }

    applySearch(value) {

        this.filter('search', value);

    }

    findBySlug(slug, arr) {
        if (!arr) return;
        let items = arr.filter(item => item.slug === slug);
        return (items[0]) ? items[0] : null
    }

    mapChurchSuiteCategories() {

        // Guard: Categories not loaded yet.
        if (!this.props.groups.groups) return [];

        // Get Categories From Groups
        let categories = [];
        let keys = {};
        Object.keys(this.props.groups.groups).map(key => {

            let group = this.props.groups.groups[key];

            // Go Through The Cats
            group.categories.map((cat, index) => {

                if (!keys[cat]) {
                    keys[cat] = cat;
                    categories.push({ value: cat, title: cat, id: index })
                }
            })

        })

        categories = [{ value: '', title: 'All', id: 'all' }, ...categories];
        return categories;
    }

    mapCCBCategories() {

        // Guard: Categories not loaded yet.
        if (!this.props.groups.groups) return [];

        // Get Categories From Groups
        let categories = [];
        let keys = {};
        Object.keys(this.props.groups.groups).map(key => {

            let group = this.props.groups.groups[key];

            // Go Through The Cats
            group.categories.map((cat, index) => {

                if (!keys[cat]) {
                    keys[cat] = cat;
                    categories.push({ value: cat, title: cat, id: index })
                }
            })

        })

        categories = [{ value: '', title: 'All', id: 'all' }, ...categories];
        return categories;
    }

    mapCategories() {

        // Original Way Coming From the Server
        // let categories = (!this.props.groups.categories) ? [] : this.props.groups.categories.map(item => { return {value:item.slug,title:item.name,id:item.term_id}; });
        // categories = [{value:'',title:'All',id:'all'},...categories];
        // return categories;

        if (this.props.source == 'ccb') return this.mapCCBCategories();
        if (this.props.source == 'churchsuite') return this.mapChurchSuiteCategories();

        // Guard: Categories not loaded yet.
        if (!this.props.groups.categories) return [];

        // Get Categories From Groups
        let categories = [];
        let keys = {};
        Object.keys(this.props.groups.groups).map(key => {

            let group = this.props.groups.groups[key];

            // Go Through The Cats
            group.categories.map(cat => {
                if (!keys[cat]) {
                    keys[cat] = cat;
                    let tax = this.findBySlug(cat, this.props.groups.categories);
                    if (tax) categories.push({ value: tax.slug, title: tax.name, id: tax.term_id })
                }
            })

        })

        // Sort
        let sorted = this.sortArrayByKey(categories, 'value');
        categories = [{ value: '', title: 'All', id: 'all' }, ...categories];
        return categories;

    }
    sortArrayByKey(arr, key) {
        return arr.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
    }

    orderWhen(results) {
        results = this.sortArrayByKey(results, 'value');
        const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
        const ordered = [];
        days.map(day => {
            results.map(when => {
                const lower = when.value.toLowerCase();
                if (lower.indexOf(day) > -1) ordered.push(when);
            })
        })

        results.map(item => {
            if (!ordered.includes(item)) ordered.push(item);
        })
        return ordered;
    }

    mapWhen() {
        if (this.props.source != 'pco') {

            // Original Way Coming From The Server
            // let options = (!this.props.groups.when) ? [] : this.props.groups.when.map(item => { return {value:item,title:item,id:item}; });
            // return [{value:'',title:'All',id:'all'},...options];


            // Get Results From The Group
            let results = [];
            let keys = {};
            Object.keys(this.props.groups.groups).map(key => {

                let when = this.props.groups.groups[key].when;
                if (!when) return;
                let lowerWhen = when.toLowerCase();
                if (!keys[lowerWhen]) {
                    keys[lowerWhen] = when;
                    results.push({ value: when, title: when, id: when })
                }
            })

            // Order By Day
            const ordered = this.orderWhen(results);
            return [{ value: '', title: 'All', id: 'all' }, ...ordered];

        } else {
            let pcoOptions = (!this.props.groups) ? [] : this.getPCOWhen();
            let ordered = this.orderWhen(pcoOptions);
            return [{ value: '', title: 'All', id: 'all' }, ...ordered];
        }
    }

    getPCOWhen() {
        let distinctWhen = {}
        let pcoWhen = [];
        const filteredWhen = Object.keys(this.props.groups.groups).map(key => {
            const when = this.props.groups.groups[key].when;
            if (!when) return false;
            if (distinctWhen[when]) return false;
            pcoWhen.push({
                value: when,
                title: when,
                id: when
            });
            distinctWhen[when] = when
        });
        return pcoWhen;
    }

    mapArea() {
        if (this.props.source != 'pco') {
            // Original Way from the server
            // let options = (!this.props.groups.areas) ? [] : this.props.groups.areas.map(item => { return {value:item,title:item,id:item}; });
            // return [{value:'',title:'All',id:'all'},...options];

            // Get Results From The Group
            let results = [];
            let keys = {};
            Object.keys(this.props.groups.groups).map(key => {
                let area = this.props.groups.groups[key].area;
                if (!area) return;
                let lowerArea = area.toLowerCase();
                if (!keys[lowerArea]) {
                    keys[lowerArea] = area;
                    results.push({ value: area, title: area, id: area })
                }
            })

            results = this.sortArrayByKey(results, 'value');
            return [{ value: '', title: 'All', id: 'all' }, ...results];
        } else {
            let pcoOptions = (!this.props.groups) ? [] : this.getPCOArea();
            return [{ value: '', title: 'All', id: 'all' }, ...pcoOptions];
        }
    }

    getPCOArea() {
        let distinct = {}
        let pco = [];
        const filtered = Object.keys(this.props.groups.groups).map(key => {
            const area = this.props.groups.groups[key].area;
            if (!area) return false;
            if (distinct[area]) return false;
            pco.push({
                value: area,
                title: area,
                id: area
            });
            distinct[area] = area
        });
        return pco;
    }


    renderBody() {

        // Guard: Not loaded
        if (this.props.groups.ui === 'loading') return (<div className={this.state.className}><Spinner /></div>);

        return (<div className="posts-loop"><TransitionGroup>{this.renderCards()}</TransitionGroup></div>);

    }

    filterGroups() {

        let f = {};

        let filtered = Object.keys(this.props.groups.groups).map(key => {

            let item = this.props.groups.groups[key];


            // PCO Bug: Shows Lat/Lng for hidden. Remove this.
            if (item && item.address && item.address.address == 'hidden') {
                item = { ...item }
                item.area = null;
                item.address = null;
            }


            // Build Search String
            let searchable = '';
            searchable += (item.title) ? item.title.toLowerCase() + ' ' : '';
            searchable += (item.content) ? item.content.toLowerCase() + ' ' : '';
            searchable += (item.address && item.address.address) ? item.address.address.toLowerCase() + ' ' : '';
            searchable += (item.area) ? item.area.toLowerCase() + ' ' : '';
            searchable += (item.time) ? item.time.toLowerCase() + ' ' : '';
            searchable += (item.when) ? item.when.toLowerCase() + ' ' : '';

            // Filter: Area
            if (this.state.area && item.area && item.area.toLowerCase() != this.state.area.toLowerCase()) return null;
            if (this.state.when && item.when && item.when.toLowerCase() != this.state.when.toLowerCase()) return null;
            if (this.state.search && (searchable.indexOf(this.state.search.toLowerCase())) < 0) return null;
            if (this.state.category && item.categories && (item.categories.indexOf(this.state.category) < 0)) return null;

            f[item.ID] = item;
            return item;

        });

        // Sort By Name
        let groupsAsArray = Object.values(f);
        if (this.props.order && this.props.order != 'latest') {
            groupsAsArray.sort((a, b) => (a.title > b.title) ? 1 : -1)
        } else if (this.props.order === 'latest') {
            groupsAsArray.sort((a, b) => (a.post_date < b.post_date) ? 1 : -1)
        }

        // Set State
        this.setState({ filteredGroups: groupsAsArray });

    }

    renderCards() {

        if (!this.state.filteredGroups) return this.filterGroups();

        const target = (this.props.source === 'pco' || this.props.source === 'churchsuite') ? '_blank' : '';

        let count = 0;

        return this.state.filteredGroups.map(item => {
            if (this.props.limit && count >= this.props.limit) return;
            count++;



            if (this.props.theme == '2017') return (<CSSTransition key={item.ID} timeout={200} classNames="listtransition"><TwentySeventeenGroupCard {...item} key={item.ID} target={target} /></CSSTransition>);
            if (this.props.theme == 'emphasis') return (<CSSTransition key={item.ID} timeout={200} classNames="listtransition"><EmphasisGroupCard {...item} key={item.ID} target={target} /></CSSTransition>);
            return (<CSSTransition key={item.ID} timeout={200} classNames="listtransition"><DefaultCard {...item} key={item.ID} target={target} /></CSSTransition>)
        })


    }



    render() {

        // Guard: Not loaded
        if (!this.props.groups.groups) return (<div className={this.state.className}><Spinner /></div>);

        let showCategoryMenu = true;
        if (this.props.source == 'pco') showCategoryMenu = false;
        if (this.props.source == 'ccb' && this.props.ccbcategory) showCategoryMenu = false;

        return (
            <div className={this.state.className}>

                {(this.state.showfilters === true && (<div className="NavigationBar">

                    <SearchInput name="search" placeholder="Search" onChange={(value) => this.applySearch(value)} />

                    {showCategoryMenu && (
                        <SelectMenu name="category" title={this.state.typeLabel} onChange={(e) => this.applyFilter(e)} options={this.mapCategories()} />
                    )}

                    <SelectMenu name="when" title={this.state.whenLabel} onChange={(e) => this.applyFilter(e)} options={this.mapWhen()} />

                    <SelectMenu name="area" title={this.state.regionLabel} onChange={(e) => this.applyFilter(e)} options={this.mapArea()} />

                    <button onClick={() => this.setState({ showMap: !this.state.showMap })}>
                        <span className="icon icon-location"></span>
                    </button>

                </div>))}

                <TransitionGroup>
                    {(this.state.showMap && this.state.filteredGroups && (

                        <CSSTransition key={1} timeout={200} classNames="map-transition">
                            <div className="groups-map">
                                <TCCGroupsOpenMap zoom={this.state.zoom} groups={this.state.filteredGroups} center={this.props.settings.address} />
                            </div>
                        </CSSTransition>

                    ))}
                </TransitionGroup>

                <div className="groups-results">

                    {this.renderBody()}

                </div>

            </div>
        );
    }

}

const mapStateToProps = state => ({
    settings: state.Settings,
    groups: state.Groups
})

const mapDispatchToProps = dispatch => ({
    configure: (site) => dispatch(configure(site)),
    getConfiguration: () => dispatch(getConfiguration()),
    getGroups: (args) => dispatch(getGroups(args)),
    getFilters: (args) => dispatch(getFilters(args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TCCGroups);
